<template>
  <div>
    <v-card-title>
      Создание GSA
    </v-card-title>
    <v-card-text>
      <v-stepper v-model="step" color="green">
        <v-stepper-header >
          <GsaStepHeader
            step="1"
            :complete="dealer_id > 0"
            editable
          >
            Выбор дилера
          </GsaStepHeader>
          
          <GsaStepHeader
            step="2"
            :complete="object_id > 0"
            :editable="dealer_id > 0"
          >
            Выбор объекта
          </GsaStepHeader>
          
          <GsaStepHeader
            step="3"
            :complete="master_id > 0"
            :editable="dealer_id > 0 && object_id > 0"
          >
            Выбор мастер-лицензии
          </GsaStepHeader>
          
          <GsaStepHeader
            step="4"
            :editable="dealer_id > 0 && object_id > 0 && master_id > 0"
          >
            Завершение
          </GsaStepHeader>
        </v-stepper-header>

        <v-stepper-items>
          <GsaDealer 
            v-model="dealer_id"
            @next="step=2" 
            step="1" 
          />
          
          <GsaObject 
            v-model="object_id"
            :dealer_id="dealer_id"
            @next="step=3" 
            @back="step=1"
            step="2" 
          />
          
          <GsaLicense 
            v-model="master_id"
            @next="step=4" 
            @back="step=2"
            :object_id="object_id"
            step="3" 
          />

          <GsaApprove
            v-model="comment"
            @back="step=3"
            @next="$emit('created', item)"
            :master_id="master_id"
            step="4" 
          />
        </v-stepper-items>

      </v-stepper>
    </v-card-text>
  </div>
</template>

<script>
import GsaStepHeader from './gsa_steps/GsaStepHeader.vue'
import GsaDealer from './gsa_steps/GsaDealer.vue'
import GsaObject from './gsa_steps/GsaObject.vue'
import GsaLicense from './gsa_steps/GsaLicense.vue'
import GsaApprove from './gsa_steps/GsaApprove.vue'

export default {
  data: () => ({
    step: 1,
    dealer_id: 0,
    object_id: 0,
    master_id: 0,
    comment: ''
  }),
  computed:{
    item(){
      return {
        dealer_id: this.dealer_id,
        object_id: this.object_id,
        master_id: this.master_id,
        comment: this.comment
      }
    }
  },
  components:{
    GsaDealer,
    GsaObject,
    GsaLicense,
    GsaApprove,
    GsaStepHeader,
  }
}
</script>